var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcShipping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_shipping") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_shipping",
    transform: "translate(0.374492, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.85,3 C2.93871875,3 2.2,3.71353516 2.2,4.59375 L2.2,6.1875 L0.55,6.1875 C0.246228125,6.1875 0,6.4265625 0,6.71875 C0,7.0109375 0.246228125,7.25 0.55,7.25 L9.35,7.25 C9.6525,7.25 9.9,7.4890625 9.9,7.78125 C9.9,8.0734375 9.6525,8.3125 9.35,8.3125 L1.65,8.3125 C1.346125,8.3125 1.1,8.5515625 1.1,8.84375 C1.1,9.1359375 1.346125,9.375 1.65,9.375 L8.25,9.375 C8.5525,9.375 8.8,9.6140625 8.8,9.90625 C8.8,10.1984375 8.5525,10.4375 8.25,10.4375 L0.55,10.4375 C0.246228125,10.4375 0,10.6765625 0,10.96875 C0,11.2609375 0.246228125,11.5 0.55,11.5 L7.15,11.5 C7.4525,11.5 7.7,11.7390625 7.7,12.03125 C7.7,12.3234375 7.4525,12.5625 7.15,12.5625 L2.2,12.5625 L2.2,16.8125 C2.2,18.5722656 3.6471875,20 5.5,20 C7.321875,20 8.8,18.5722656 8.8,16.8125 L13.2,16.8125 C13.2,18.5722656 14.6471875,20 16.5,20 C18.321875,20 19.8,18.5722656 19.8,16.8125 L20.9,16.8125 C21.5084375,16.8125 22,16.3376953 22,15.75 C22,15.1623047 21.5084375,14.6875 20.9,14.6875 L20.9,10.8791016 C20.9,10.3146484 20.6696875,9.7734375 20.2571875,9.375 L17.6,6.80839844 C17.1565625,6.40996094 16.6271875,6.1875 16.0428125,6.1875 L14.3,6.1875 L14.3,4.59375 C14.3,3.71353516 13.5609375,3 12.65,3 L3.85,3 Z M18.7,10.8791016 L18.7,11.5 L14.3,11.5 L14.3,8.3125 L16.0428125,8.3125 L18.7,10.8791016 Z M5.5,18.40625 C4.5890625,18.40625 3.85,17.6923828 3.85,16.8125 C3.85,15.9326172 4.5890625,15.21875 5.5,15.21875 C6.4109375,15.21875 7.15,15.9326172 7.15,16.8125 C7.15,17.6923828 6.4109375,18.40625 5.5,18.40625 Z M18.15,16.8125 C18.15,17.6923828 17.4109375,18.40625 16.5,18.40625 C15.5890625,18.40625 14.85,17.6923828 14.85,16.8125 C14.85,15.9326172 15.5890625,15.21875 16.5,15.21875 C17.4109375,15.21875 18.15,15.9326172 18.15,16.8125 Z",
    id: "Shape",
    fill: "#05315F",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShipping);
export default __webpack_public_path__ + "static/media/ic_shipping.9131c04eab47da87ae990fc47d982193.svg";
export { ForwardRef as ReactComponent };